import { CusaC360B2bSnrComponent } from "./CusaC360B2bSnrComponent";

export function CusaC360B2bSnrScreen() {
  return (
    <>
      <CusaC360B2bSnrComponent />
    </>
  );
}
